export default "__VITE_PUBLIC_ASSET__82e771b0__"